module.exports = __webpack_public_path__ + "static/media/idea-and-generation.34c37271.svg";